// extracted by mini-css-extract-plugin
export default {"loading_section":"Loading_loading_section__6Z9X0","loading_spinner":"Loading_loading_spinner__JARFP"};